import { Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AbstractControl } from '@angular/forms';

export const signalValueChanges = <T extends AbstractControl>(
  control: T,
  options?: Parameters<typeof toSignal>[1],
): Signal<T['value']> =>
  toSignal(control.valueChanges, {
    ...options,
    requireSync: false,
    initialValue: control.value,
  });
